import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, object = auth, false = not
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("lf_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        setProfile(data.profile);
      })
      .catch(() => {
        localStorage.removeItem("lf_token");
        setUser(false);
      });
  }, []);

  const persist = (data) => {
    localStorage.setItem("lf_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
    const me = await api.get("/auth/me");
    setProfile(me.data.profile);
    return me.data.profile;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    persist(data);
    const me = await api.get("/auth/me");
    setProfile(me.data.profile);
    return me.data.profile;
  };

  const logout = () => {
    localStorage.removeItem("lf_token");
    setUser(false);
    setProfile(null);
  };

  return (
    <AuthContext.Provider value={{ user, profile, setProfile, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
